import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortNumber',
    pure: true
})
export class ShortNumberPipe implements PipeTransform {
    transform(number: any, ...args: unknown[]): unknown {
        return this.shortNumber(number);
    }

    shortNumber(number) {
        if (typeof number == 'string') {
            number = number.replace(',', '');
            number = parseFloat(number);
        }
        if (isNaN(number)) return null; // will only work value in a number
        if (number === null) return null;
        if (number === 0) return 0;
        let abs: any = Math.abs(number);
        const rounder = Math.pow(10, 1);
        const isNegative = number < 0; // will also work for Negative numbers
        let key = '';

        const powers = [
            { key: 'Q', value: Math.pow(10, 15) },
            { key: 'T', value: Math.pow(10, 12) },
            { key: 'B', value: Math.pow(10, 9) },
            { key: 'M', value: Math.pow(10, 6) },
            { key: 'K', value: Math.pow(10, 3) }
        ];

        let reduced = abs / powers[3].value;
        reduced = Math.round(reduced * rounder) / rounder;
        if (reduced >= 1) {
            abs = reduced;
            key = powers[3].key;
        }

        let numberInMillion: string;
        if (!key) {
            numberInMillion = parseFloat(abs).toFixed(2);
        } else {
            numberInMillion = (isNegative ? '-' : '') + abs + key;
        }
        // Return the number with commas in the thousand separator
        return numberInMillion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
}
